import React, { Fragment } from 'react';
import { ReactComponent as ErrorNotFound } from '../../img/error-not-found.svg';

export const NotFound = () => {
  return (
    <Fragment>
      <div className='container'>
        <div className='row all-center'>
          <div className='col'>
            <ErrorNotFound
              className='img-fluid w-50'
              style={{ margin: '60px 0 100px 0', minHeight: '698px' }}
            />
          </div>
        </div>
      </div>
    </Fragment>
  );
};

export default NotFound;
